<template>
	<section class="main-content align-center faq-section background-dark">
		<div class="row faq">
			<h2>{{ header }}</h2>
			<div v-for="item in items" :key="item.ID" class="columns column12 faq-item">
				<collapse :header="item.question" :content="item.answer" />
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.faq-section + .faq-section {
	padding-top: 0;
}

.row {
	overflow: hidden;
	width: 100%;
	display: inline-block;
	font-size: 0;
	vertical-align: top;
	padding-bottom: 75px;
	text-align: left;

	&:last-child {
		padding-bottom: 0;
	}

	h2 {
		margin-bottom: 70px;
		text-align: center;

		::before {
			background-color: #ff9700;
			bottom: -1px;
			content: '';
			display: block;
			left: 0;
			position: absolute;
			top: 0;
			width: 10px;
		}
	}
}

@media (max-width: 960px) {
	.faq-item {
		padding: 5px 15px;
	}
}
</style>
